import { FC } from 'react';

import classes from './Title.module.scss';
import Heart from '../../assets/heart.png';

const Title: FC = () => {
  return (
    <header className={classes.invitationTitle}>
      <h1>
        한도형 <img src={Heart} alt="heart" /> 심명보
      </h1>
      <p>2023. 03. 18.(토) 11:30</p>
    </header>
  );
};

export default Title;
